export const CAPTCHA_KEY =
  'ysc1_vitLCOs3cQJS4lK0qYoAIf54sPlB6danuaNFHPtO53bcd15d';

/**
 * Выключатель Yandex SmartCaptcha на входе, регистрации и восстановлении пароля.
 * false — на случай недоступности SmartCaptcha: виджет не рендерится, его скрипт
 * не грузится, вместо токена уходит CAPTCHA_DISABLED_TOKEN. Выключать только
 * вместе с бэкендом (`store.yandex_captcha.is_enabled: false`), иначе он
 * отклонит заглушку; включать — фронт раньше бэкенда.
 */
export const CAPTCHA_ENABLED = true;

export const CAPTCHA_DISABLED_TOKEN = 'captcha-disabled';
